import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CookieIcon from "@mui/icons-material/Cookie";
import ActionButton from "./ActionButton";

const CookieConsentDialog = ({ open, onClose, onAccept, onDecline }) => {
  return (
    <Dialog open={open} onClose={onClose} sx={{ textAlign: "center", margin: "auto", width: "100%" }}>
      <CookieIcon sx={{ width: "100px", height: "100px", marginLeft: "41%", mt: 3, color: 'primary.main' }} />
      <DialogTitle>Cookie Consent</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "#000" }}>
          This website has optional cookies which will be applied to your computer with your consent.
These Cookies are performance and analytical cookies designed to track and measure your engagement with our website, any data captured by these cookies are promptly anonymised.
For more information, please visit our cookies policy by <a href="/CookiePolicy" target="_blank" style={{ color: '#005969', textDecoration: "underline" }}>clicking here.</a>
          <br /><br />
          Do you accept these cookies operating on your device?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
        <ActionButton
          variant='contained'
          buttonColor='secondary.main'
          buttonTextColor='primary.contrastText'
          borderColor='transparent'
          hoverColor='primary.contrastText'
          hoverBorderColor='secondary.main'
          hoverTextColor='secondary.main'
          buttonTitle='Accept'
          onClick={onAccept}
        />
        <ActionButton
          borderColor='primary.dark'
          buttonColor='transparent'
          buttonTextColor='primary.dark'
          buttonTitle='Decline'
          variant='outlined'
          hoverColor='primary.dark'
          hoverBorderColor={"primary.dark"}
          hoverTextColor='secondary.contrastText'
          onClick={onDecline}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CookieConsentDialog;
